import {Component} from "@angular/core";
import {ModalService} from "../../../shared/modal/modal.service";

@Component({
  templateUrl: './battery.scores.modal.template.html'
})

export class BatteryScoresModalComponent extends ModalService implements IModalService {
}
